import { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import showDialog from "../../../utils/ShowDialog/ShowDialog";
import ReadLocation from "./readLocation.view";
import * as LocationServices from "../../../../services/LocationServices";
import { LOCATION_TYPE_ENTRY, LOCATION_TYPE_ROOM } from "../../../../constants";

export const useReadLocation = (processType) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [initial, setInitial] = useState({});
  const [loading, setLoading] = useState(false);
  const [location, setLocation] = useState(null);

  function obtenerDiaJuliano(fecha) {
    var inicioAño = new Date(fecha.getFullYear(), 0, 0);
    var milisegundosEnUnDia = 86400000; // 24 horas * 60 minutos * 60 segundos * 1000 milisegundos
    var diferencia = fecha - inicioAño;
    var diaJuliano = Math.floor(diferencia / milisegundosEnUnDia);

    return diaJuliano;
  }

  const handleScanBarCode01 = async (codeInit) => {
    // const tt = "02000000710001011123083017241129371000";
    const code = `${codeInit}`;

    // const initCode01 = tt.substring(0, 2);
    const idItem = code.substring(2, 16); //itemCode
    // const initCode02 = tt.substring(16, 18);
    const productionDate = code.substring(18, 24);
    // const initCode03 = tt.substring(24, 26);
    const validateDate = code.substring(26, 32);
    // const initCode04 = tt.substring(32, 34);
    const weight = code.substring(34); //outWeight

    const yearP = productionDate.substring(0, 2);
    const monthP = productionDate.substring(2, 4);
    const dayP = productionDate.substring(4);

    const yearV = validateDate.substring(0, 2);
    const monthV = validateDate.substring(2, 4);
    const dayV = validateDate.substring(4);

    const newInitial = { ...initial };
    newInitial.itemCode = `${Number(idItem)}`;
    newInitial.productionDate = new Date(`20${yearP}-${monthP}-${dayP}`);
    // newInitial.harvestYear = Number(`20${yearP}`);
    newInitial.validateDate = new Date(`20${yearV}-${monthV}-${dayV}`);
    newInitial.outWeight = Number(weight);

    setInitial(newInitial);
  };

  const handleScanBarCode02 = async (codeInit) => {
    // const tt = "000000000000002356171023242G5819";
    const code = `${codeInit}`;
    // if (code.length === 34 || code.length === 35) {
    // const initCode01 = code.substring(0, 2);
    const sscc = code.substring(2, 20); //sscc
    // const initCode02 = code.substring(18, 20);
    const batchCode = code.substring(22); //outBatch

    const newinitial = { ...initial };
    newinitial.outBatch = batchCode;
    newinitial.sscc = sscc;

    newinitial.harvestYear = Number(`20${batchCode.substring(0, 2)}`);

    let juliano = batchCode.substring(2, 5);

    const currentJuliano = obtenerDiaJuliano(new Date()) + "";
    if (juliano && currentJuliano !== juliano) {
      const okAction = () => {
        setInitial(newinitial);
      };

      const cancelAction = () => {
        // setWorkPartidora(false);
        // nextStep();
      };

      showDialog(
        t("forms.process.dialog.juliano.title"),
        t("forms.process.dialog.juliano.text"),
        "warning",
        true,
        t("forms.process.dialog.juliano.buttonOk"),
        false,
        okAction,
        t("forms.process.dialog.juliano.buttonNo"),
        cancelAction
      );
    } else {
      setInitial(newinitial);
    }
  };

  const handlerClosePopup = (resetForm, handlerReset) => {
    if (resetForm) {
      resetForm();
    }
    setInitial({});
    handlerReset();
  };

  // const handleNextToProductReader = async ({ type, processData }) => {
  //   // if (
  //   //   type === REPROCESS_TYPE &&
  //   //   processData &&
  //   //   processData.workAlone === false &&
  //   //   processData.orderOpen
  //   // ) {
  //   //   const okAction = () => {
  //   //     setWorkPartidora(true);
  //   //     nextStep();
  //   //   };
  //   //   const cancelAction = () => {
  //   //     setWorkPartidora(false);
  //   //     nextStep();
  //   //   };
  //   //   showDialog(
  //   //     t("forms.process.dialog.workAlone.title"),
  //   //     t("forms.process.dialog.workAlone.text"),
  //   //     "warning",
  //   //     true,
  //   //     t("forms.process.dialog.workAlone.buttonOk"),
  //   //     false,
  //   //     okAction,
  //   //     t("forms.process.dialog.workAlone.buttonNo"),
  //   //     cancelAction
  //   //   );
  //   // } else if (
  //   //   type === REPROCESS_TYPE &&
  //   //   processData &&
  //   //   processData.workAlone === false &&
  //   //   !processData.orderOpen
  //   // ) {
  //   //   setWorkPartidora(false);
  //   //   nextStep();
  //   // } else {
  //   //   if (processData && processData.isPrincipalMachine === true) {
  //   //     const okAction = () => {
  //   //       setIsPrincipal(true);
  //   //       nextStep();
  //   //     };
  //   //     const cancelAction = () => {
  //   //       setIsPrincipal(false);
  //   //       nextStep();
  //   //     };
  //   //     showDialog(
  //   //       t("forms.process.dialog.isPrincipal.title"),
  //   //       t("forms.process.dialog.isPrincipal.text"),
  //   //       "warning",
  //   //       true,
  //   //       t("forms.process.dialog.isPrincipal.buttonOk"),
  //   //       false,
  //   //       okAction,
  //   //       t("forms.process.dialog.isPrincipal.buttonNo"),
  //   //       cancelAction
  //   //     );
  //   //   } else {
  //   //     nextStep();
  //   //   }
  //   // }
  // };

  const onDetectedMachineCode = async (error, data) => {
    if (data) {
      LocationServices.getLocationMov(data).then((result) => {
        if (result && result.type === LOCATION_TYPE_ROOM) {
          setLocation(result);
          // handleNextToProductReader({ type: typeD, processData: result });
        }
      });
    }
  };

  const handleScanMachine = useCallback(async (value) => {
    await onDetectedMachineCode("", value);
    // handleNextToProductReader();
  }, []);

  const handleOnCleanMachine = async () => {
    // setType("");
    // setProcessData(null);
    // setWorkPartidora(null);
  };

  const setLoadingData = async () => {
    setLoading(true);
  };

  const readLocation = () => {
    return (
      <ReadLocation
        // onSubmit={handleNextToProductReader}
        onScan1={handleScanMachine}
        onClean={handleOnCleanMachine}
        loading={loading}
        setLoadingData={setLoadingData}
      />

      // <ReadLocation
      //   type={type}
      //   outPoints={outPoints}
      //   processType={processType}
      //   action={action}
      //   initialValues={initial}
      //   onSubmit={
      //     type
      //       ? (values) =>
      //           registerBB(type, values, () =>
      //             handlerClosePopup(null, handlerReset)
      //           )
      //       : (values) =>
      //           createStandAloneProcess(values, () =>
      //             handlerClosePopup(null, handlerReset)
      //           )
      //   }
      //   onScan1={handleScanBarCode01}
      //   onScan2={handleScanBarCode02}
      //   goBack={(resetForm) => handlerClosePopup(resetForm, handlerReset)}
      // />
    );
  };

  return {
    readLocation,
    location,
  };
};
